import { VerticalFormItem } from '@components/display';
import {
  BG_COLORS,
  Form,
  IAvailableIcons,
  IconSearch,
  Row,
  TextInput,
} from 'common-components';
import { css } from '@emotion/react';
import { useAppTranslation } from '@hooks';
import { getStateKeyByValue } from '@utils';
import { SegmentDefType, SegmentTypeType } from '@definitions';
import { Dispatch, SetStateAction } from 'react';

import PillComponent from './Pill';
import { SegmentFormType } from './CreateSegmentModal';

export type SegmentTypeSelectPropsType = {
  segmentForm: SegmentFormType
  setSegmentForm: Dispatch<SetStateAction<SegmentFormType>>
};

const PILL_DATA: Readonly<{
  id: SegmentTypeType
  icon: IAvailableIcons
  title: string
  text: string
}>[] = [
  {
    id: getStateKeyByValue(SegmentDefType, 'sociodemographic'),
    icon: 'UserCircle',
    title: 'socio',
    text: 'defineSelectionCriteria',
  },
  {
    id: getStateKeyByValue(SegmentDefType, 'manual'),
    icon: 'Hand',
    title: 'manual',
    text: 'manualContributorSelection',
  },
  /* HIDE
	 * {
		id: getStateKeyByValue(SegmentType, "certification") as TSegmentDefType,
		icon: "Star02" as IAvailableIcons,
		title: "competence",
		text: "specificCompetenceSelection",
	},*/
];

const TypeSegmentSelect = ({ segmentForm, setSegmentForm }: SegmentTypeSelectPropsType) => {
  const { translate } = useAppTranslation();

  return (
    <Form
      css={css`
        display: flex;
        flex-direction: column;
        gap: 20px;
        margin-top: 20px;
      `}
    >
      <Row
        wrap={false}
        css={css`
          gap: 20px;
        `}
      >
        <VerticalFormItem label={translate('createSegment.icon')}>
          <IconSearch
            value={segmentForm?.icon}
            bgColors={BG_COLORS}
            onSubmit={(icon) =>
              setSegmentForm((prev) => ({
                ...prev,
                icon,
              }))
            }
          />
        </VerticalFormItem>
        <VerticalFormItem style={{ flexGrow: 1 }} label={translate('createSegment.name')}>
          <TextInput
            onBlur={(e) =>
              setSegmentForm((prev) => ({
                ...prev,
                name: e.target.value,
              }))
            }
            placeholder={translate('createSegment.exampleEnglishLevel1')}
          />
        </VerticalFormItem>
      </Row>
      <Row
        css={css`
          display: grid;
          grid-template-columns: repeat(${PILL_DATA.length}, 1fr);
          gap: 10px;
        `}
      >
        {PILL_DATA.map((elem) => (
          <PillComponent key={elem.id}
            elem={elem}
            segmentType={segmentForm?.segmentType}
            setSegmentType={(value) =>
              setSegmentForm((prev) => ({
                ...prev,
                segmentType: value,
              }))
            }
          />
        ))}
      </Row>
    </Form>
  );
};

export default TypeSegmentSelect;
